import {
  TBtnElement,
  TTooltipType,
  TTooltipPosition,
  TScrollableParentRefType
} from '../types'

import { useTooltipVisibility } from './use-tooltip-visibility'
import { useTooltipPositioning } from './use-tooltip-positioning'

export const useTooltipData = ({
  btnElement,
  scrollableParentRef,
  showMobileTooltip,
  tooltipPosition,
  tooltipWrapperRef,
  type,
  isToggledByClick
}: {
  btnElement: TBtnElement
  scrollableParentRef: TScrollableParentRefType
  showMobileTooltip: boolean
  tooltipPosition: TTooltipPosition
  tooltipWrapperRef: HTMLDivElement | null
  type: TTooltipType
  isToggledByClick?: boolean
}) => {
  const isVisible = useTooltipVisibility({
    btnElement,
    scrollableParentRef,
    showMobileTooltip,
    type,
    isToggledByClick
  })

  const { position, arrowStyles } = useTooltipPositioning({
    tooltipPosition,
    tooltipWrapperRef,
    btnElement,
    scrollableParentRef,
    type
  })

  return {
    isVisible,
    position,
    arrowStyles
  }
}
